export const formatArea = (area: string): string => {
  return area.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};

export const formatAreaShort = (area: string): string => {
  const upper = area.toUpperCase();
  if (!/[_\s]/.test(upper)) return upper;
  return upper
    .split(/[_\s]+/)
    .map((part) => (/^\d+$/.test(part) ? part : part.charAt(0)))
    .join("");
};
